import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { PublicClientApplication, InteractionStatus, EventType, EventMessage, AuthenticationResult } from '@azure/msal-browser';
import { msalConfig } from './authConfig';
import { MsalProvider, AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import { loginRequest } from './authConfig';
import React, { useEffect } from 'react';
import { ErrorBoundary } from './components/ErrorBoundary';

const msalInstance = new PublicClientApplication(msalConfig);
if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
    msalInstance.setActiveAccount(msalInstance.getActiveAccount()[0]);
}

msalInstance.addEventCallback((event: EventMessage) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
        const payload = event.payload as AuthenticationResult;
        const account = payload.account;
        msalInstance.setActiveAccount(account);
    }
});

const AuthRedirect: React.FC = () => {
    const { instance, inProgress } = useMsal();

    useEffect(() => {
        if (inProgress === InteractionStatus.None) {
            instance.loginRedirect(loginRequest).catch((error) => {
                console.error("Login redirect failed:", error);
            });
        }
    }, [inProgress, instance]);

    return (
        <div className="login-container">
            <h2>Redirecting to Microsoft login...</h2>
            <p>Please wait while we redirect you to the login page.</p>
        </div>
    );
};

const AppWithAuthentication = () => (
    <ErrorBoundary>
        <MsalProvider instance={msalInstance}>
            <AuthenticatedTemplate>
                <App />
            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>
                <AuthRedirect/>
            </UnauthenticatedTemplate>
        </MsalProvider>
    </ErrorBoundary>
);
const root = createRoot(document.getElementById('root'));
root.render(
    <AppWithAuthentication />
);
